import i18next from "i18next";
import { useQuery } from "react-query";
import { z } from "zod";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export const SAML2_PROVIDERS_ENDPOINT = "/api/auth/saml2-providers" as const;

export const getAllSaml2ProvidersKey = "getAllSaml2Providers" as const;

export const Saml2ProviderSchema = z.object({
    "@id": z.string(),
    id: z.number(),
    providerName: z.string(),
    label: z.string().nullable().optional(),
    idpEntityId: z.string(),
    idpSsoUrl: z.string(),
    idpSloUrl: z.string(),
    idpCert: z.string(),
    spEntityId: z.string(),
    spAcsUrl: z.string(),
    spSloUrl: z.string(),
    identifierAttribute: z.string(),
    redirectUrl: z.string().nullable().optional(),
});

export type Saml2Provider = z.infer<typeof Saml2ProviderSchema>;

type Options = {
    enabled?: boolean;
};

export const useGetAllSaml2Providers = (options?: Options) => {
    const query = useQuery({
        queryKey: [getAllSaml2ProvidersKey, i18next.resolvedLanguage],
        enabled: options?.enabled ?? true,
        queryFn: async () => {
            return loggedInApiCall.get(SAML2_PROVIDERS_ENDPOINT, { params: { itemsPerPage: 100 } });
        },
        select: (request) => {
            const data = request.data["hydra:member"];
            return zodParseWithDetailedLog(data, Saml2ProviderSchema.array(), {
                operation: "GET",
                endpoint: SAML2_PROVIDERS_ENDPOINT,
            });
        },
    });

    return {
        saml2Providers: query.data,
        ...query,
    };
};
